// Jednostki i transformacje. Swiat fizyki: metry/kg/sekundy, os Y w gore.
// Siatka edytora jest zorientowana tak samo jak swiat (y w gore);
// tylko render odwraca os Y na ekranowa.

/** Jedna jednostka klockowa = 0,25 m w swiecie fizyki. */
export const METERS_PER_GRID = 0.25;

export function gridToMeters(grid: number): number {
  return grid * METERS_PER_GRID;
}

export function metersToGrid(meters: number): number {
  return meters / METERS_PER_GRID;
}

/** Stopnie (0/90/180/270) na radiany. */
export function degreesToRadians(degrees: number): number {
  return (degrees * Math.PI) / 180;
}
